import { PlatformModel } from '~/models/PlatformModel';
import { MFAStatus } from '~/repositories';

export const isAllowedAppAccess = (
  currentPlatform?: PlatformModel,
  mfaStatus?: MFAStatus,
  featureFlagRequireLiveVerification?: boolean
): boolean => {
  if (!featureFlagRequireLiveVerification) {
    return currentPlatform !== undefined;
  }

  return currentPlatform !== undefined && (!currentPlatform.isLiveEnabled || mfaStatus === MFAStatus.VERIFIED);
};
